module.exports = __webpack_public_path__ + "static/image_001-b379675c0c14aa7e3dc7a48c33cb78f3.png";